module.exports = __webpack_public_path__ + "img/rosa.b8c04597.png";